import CodingEntityDropdown from 'app/pages/overview/tabs/transactions/CodingEntityDropdown';
import { AgaveVendor } from 'API';
import { selectAgaveSlice } from 'app/pages/store/agaveSlice';
import { useAppSelector } from 'app/store';
import { selectUserCompanies } from 'app/store/userCompaniesSlice';
import { supportsCodeSort } from 'util/codingSortSetting';

interface AgaveVendorsDropdownProps {
  disabled?: boolean;
  disableHeader?: boolean;
  selectedVendor?: AgaveVendor | null;
  onValueChange: (option: AgaveVendor | null) => void;
  placeholder?: string | null;
  enabled?: boolean;
}

const AgaveVendorsDropdown = ({
  disabled,
  disableHeader = true,
  selectedVendor,
  onValueChange,
  placeholder,
  enabled = true,
}: AgaveVendorsDropdownProps) => {
  // SEE-1325: show the Vista vendor number. Vendors are the one coding entity
  // whose identifier was the name itself, so the label read
  // "Speedchain - (Speedchain)". Griffith has three vendors all named
  // "Speedchain" (codes 1, 2 and 6) and the number is the only thing that tells
  // them apart — picking the wrong one sends the invoice to the wrong AP
  // company.
  //
  // SEE-1622: every direct ERP with meaningful codes, not just Vista — once
  // vendors are server-sorted by code for them, a label without the code reads
  // as random ("(SPEEDCHAIN) - SPEEDCHAIN" in code order). QuickBooks, Agave and
  // no-ERP paidols keep the name-only label (QB vendor "codes" are internal
  // ids). NOT gated on the dropdown-sort toggle: the code is what disambiguates
  // duplicates regardless of ordering.
  const { selectedPaidol } = useAppSelector(selectUserCompanies);
  const { agaveAccount } = useAppSelector(selectAgaveSlice);
  const showVendorCode = supportsCodeSort(selectedPaidol, agaveAccount?.source_system?.slug);

  return (
    <CodingEntityDropdown<AgaveVendor>
      entityType="vendors"
      selectedItem={selectedVendor}
      onValueChange={onValueChange}
      disabled={disabled}
      disableHeader={disableHeader}
      placeholder={placeholder || undefined}
      identifierField={showVendorCode ? 'code' : 'name'}
      enabled={enabled}
    />
  );
};

export default AgaveVendorsDropdown;
